/* eslint-disable */

import React, { Component } from 'react';
import Swipe from 'react-easy-swipe';

import _ from 'lodash';

import '../SwipeAdContent/SwipeAdContent';
import './SwipeCloseModal.css';
import SwipeAdContent from '../SwipeAdContent/SwipeAdContent';

export class Modal extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return !nextProps.isOnSwitching;
  }

  setRef = (element) => {
    this.modalRef = element;

    // when modal closes, the ref was not assigned. We need to check if this.modalRef is not undefined.
    if (this.modalRef) {
      const rect = this.modalRef.getBoundingClientRect();
      const threshold = rect.height / 6 + rect.y - rect.height; // substracting rect.height because we are pushing the modal 100% down when loaded.
      if (this.props.setThreshold) this.props.setThreshold(threshold);

      this.setState({
        opening: true,
        swiping: false,
        height: rect.height,
        threshold: threshold,
        originalPosition: {
          y: rect.y
        },
        currentPosition: {
          y: rect.y
        },
        diff: {
          dy: 0
        }
      });
    }
  };

  onSwipeStart = (event) => {
    const rect = this.modalRef.getBoundingClientRect();

    this.setState({
      ...this.state,
      currentPosition: {
        y: rect.y
      },
      opening: false,
      swiping: true
    });
  };
  onSwipeMove = (position, event) => {
    if (position.y < 0) return;

    if (!this.modalRef) {
      console.log('modalRef is null.');
      return;
    }

    const style = {
      transform: `translate(0px, ${position.y}px)`
    };

    const rect = this.modalRef.getBoundingClientRect();

    this.setState({
      ...this.state,
      style: style,
      currentPosition: {
        y: rect.y
      },
      diff: {
        dy: position.y
      }
    });
  };
  onSwipeEnd = (event) => {
    const opening = this.state.currentPosition.y < this.state.threshold;

    // if the modal is being closed, clear out the mobileState in the parent component that displays this modal.
    if (!opening && this.props.resetMobileStateOnModalClose)
      this.props.resetMobileStateOnModalClose();
    if (!opening && this.props.onModalClose) this.props.onModalClose();

    this.setState({
      ...this.state,
      opening: opening,
      swiping: false,
      currentPosition: {
        y: this.state.originalPosition.y
      },
      diff: {
        dy: 0
      }
    });
  };

  onCloseButtonClick = (event) => {
    if (this.props.resetMobileStateOnModalClose)
      this.props.resetMobileStateOnModalClose();
    if (this.props.onModalClose) this.props.onModalClose();

    this.setState({
      ...this.state,
      opening: false,
      swiping: false,
      currentPosition: {
        y: this.state.originalPosition.y
      },
      diff: {
        dy: 0
      }
    });
  };

  render() {
    console.log(
      'rendering SwipeCloseModal at index : ',
      this.props.previewIndex
    );
    let newStyle = {
      transform: `translate(0px, 100%)`
    };
    if (this.state) {
      if (this.state.swiping) {
        newStyle = {
          transform: `translate(0px, ${this.state.diff.dy}px)`
        };
      } else {
        // not swiping...
        if (this.state.opening) {
          newStyle = {
            transform: `translate(0px, 0px)`,
            transition: `0.2s ease-in-out`
          };
        } else {
          newStyle = {
            transform: `translate(0px, ${this.state.height}px)`,
            transition: `0.2s ease-in-out`
          };
        }
      }
    }

    return (
      <div
        className="swipe-close-modal-container"
        style={
          this.state && !this.state.swiping && !this.state.opening
            ? {
                backgroundColor: 'rgba(255,255,255, 0)',
                transform: `translate(0px, ${window.innerHeight}px)`,
                transition: `background-color 0.2s, transform 0.2s 0.2s`
              }
            : {}
        }
      >
        <div ref={this.setRef} className="swipe-close-modal" style={newStyle}>
          <Swipe
            onSwipeStart={this.onSwipeStart}
            onSwipeMove={this.onSwipeMove}
            onSwipeEnd={this.onSwipeEnd}
          >
            <div className="draggable-section"></div>
          </Swipe>
          <div className="title-section">
            <div className="title">{this.props.adTitle}</div>
            <div className="close-button" onClick={this.onCloseButtonClick}>
              x
            </div>
          </div>
          <div className={'content'}>
            <SwipeAdContent
              content={this.props.content}
              renderedPreviewIndexes={this.props.renderedPreviewIndexes}
              previewIndex={this.props.previewIndex}
            ></SwipeAdContent>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/SwipeCloseModal/SwipeCloseModal.jsx